<mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading" style="position:absolute;"></mat-progress-bar>

<div fxFlex="row" fxFlex style="width: 100%;">
    <div fxFlex="240px" class="sidenavigationTop hidexs" *ngIf="showFooter">

        <div class="iwg-service-name" *ngIf="ShowEOREstimator || !EORDisabled">Employer of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;">
            <div *ngIf="ShowEOREstimator">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickQuoteEstimator()">
                    Estimator<span flex></span>
                    <span flex></span>
                </a>
            </div>
            <div *ngIf="ShowEORQuotes && !EORDisabled">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickQuote(1)">
                    Quotes<span flex></span>
                    <span flex></span>
                </a>
            </div>
            <div *ngIf="!EORDisabled">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickAssignments(1)" [ngClass]="{' active-side-nav': selectedService==1}">
                    Assignments<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==1}"></span>
                </a>
            </div>
        </div>

        <div class="iwg-service-name" *ngIf="!ComplianceDisabled">Compliance</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!ComplianceDisabled">
            <div *ngIf="ShowComplianceQuotes">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickQuote(3)">
                    Quotes<span flex></span>
                    <span flex></span>
                </a>
            </div>
            <div>
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickAssignments(3)" [ngClass]="{' active-side-nav': selectedService==3}">
                    Evaluations<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==3}"></span>
                </a>
            </div>
        </div>

        <div class="iwg-service-name" *ngIf="!AORDisabled">Agent of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!AORDisabled">
            <div *ngIf="ShowAORQuotes">
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickQuote(2)">
                    Quotes<span flex></span>
                    <span flex></span>
                </a>
            </div>
            <div>
                <a href="javascript:void(0);" class="custom-sidemenu" layout
                   (click)="OnClickAssignments(2)" [ngClass]="{' active-side-nav': selectedService==2}">
                    Engagements<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==2}"></span>
                </a>
            </div>
        </div>


        <div class="sidenavigationInner">
            <app-buttonbar></app-buttonbar>
        </div>
    </div>

    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">
        <div *ngIf="!showFooter && this.userService.getRole() !='Worker'">
            <a mat-button href="#" *ngIf="selectedService === 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event, null, 3); $event.preventDefault();" layout="row">
                Evaluate a Contractor
                <span flex></span>
                <mat-icon  mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
            <a mat-button href="#" *ngIf="selectedService !== 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event); $event.preventDefault();" layout="row">
                Engage a Worker
                <span flex></span>
                <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
            <a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="ShowQuoteDialog_embed($event); $event.preventDefault();" layout="row">
                Get a Quote
                <span flex></span>
                <mat-icon  mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
        </div>
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span *ngIf="showFooter">Services » </span><span>{{selectedServiceName}}</span> »
                <span>{{assignmentLabelPlural}}</span> »
                <span class="iwg-page-header-small-title" *ngIf="assignment">{{assignment?.Worker?.Name}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="iwg-page-header-toolbar" layout="row" fxLayoutAlign="space-between start">

                <div>
                    <button mat-button class="mat-icon-button" style="margin-right: 6px;width: auto;padding-right: 8px;"
                            [routerLink]="['/assignments']" [queryParams]="{
                service: state.service,
                page: state.page,
                limit: state.limit,
                order_by: state.order_by,
                order: state.order,
                start: state.start,
                end: state.end,
                q: state.q,
                country: (state.country && state.country.Abbreviation ? state.country.Abbreviation : state.country),
                global_scope: state.global_scope
                }">
                        <mat-icon style="margin: 0 4px;">arrow_back</mat-icon>
                    </button>
                    <div class="iwg-page-header-title" style="line-height: 40px;display: inline;" *ngIf="assignment">
                        {{this.utils.htmlDecode(assignment?.Title)}}
                    </div>
                    <span flex></span>

                </div>


                <div class="vista-editbtna">
                    <a mat-button *ngIf="assignment && assignment?.Status.ID == 1"
                       class="mat-primary mat-raised iwg-mat-raised vista-editbtn"
                       (click)="showEditAssignmentDialog($event, assignment?.ID)"
                       layout="row">
                        Edit
                        <span flex></span>
                    </a>
                </div>

            </div>

            <div class="assignmentstabsdiv assigndetail">
                <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
                               (selectedTabChange)="onTabChanged($event);">
                    <mat-tab label="Details">
                        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
                    </mat-tab>
                    <mat-tab label="Questionnaire" *ngIf="ShowQuestionnaire">
                        <div layout="row" layout-xs="column" class="assignmentdetailscloumns" *ngIf="assignment">

                            <div>
                                <div class="iwg-widget-box" flex>
                                    <div class="iwg-widget-box-header">{{workerLabel}} Information</div>
                                    <div class="iwg-widget-box-body" layout="row">
                                        <div flex>
                                            <div class="iwg-widget-box-card">
                                                <label class="iwg-regular-label">{{workerLabel}} </label>
                                                <p class="iwg-regular-value" *ngIf="assignment?.Worker">
                                                    {{assignment?.Worker?.Name | blank}}
                                                </p>
                                            </div>
                                            <div class="iwg-widget-box-card"
                                                 *ngIf="(assignment?.Worker && assignment?.Worker?.CompanyName!= '' && assignment?.Worker?.CompanyName != null && assignment?.Worker?.CompanyName!=assignment?.Worker?.Name) && ( state.service==2 || state.service==3)">
                                                <label class="iwg-regular-label">Business Name</label>
                                                <p class="iwg-regular-value">
                                                    {{assignment?.Worker?.CompanyName | blank}}
                                                </p>
                                            </div>


                                            <div class="iwg-widget-box-card">
                                                <p class="iwg-regular-value">
                                                    <mat-icon style="float: left;">email</mat-icon>
                                                    <a target="_top" href="mailto:{{assignment?.Worker?.ContactInfo.Email | blank}}">{{assignment?.Worker?.ContactInfo.Email | blank}}</a>
                                                </p>
                                            </div>
                                            <div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="spacebw"></span>
                            <div class="iwg-widget-box" *ngIf="assignment" style="overflow:auto;">
                                <table class="questionnaireTable" flex>
                                    <thead>
                                        <tr style="height: 34px;">
                                            <th></th>
                                            <th>
                                                <div class="iwg-widget-box-header">Questions</div>
                                            </th>
                                            <th>
                                                <div class="iwg-widget-box-header">Answers</div>
                                            </th>
                                        </tr>
                                    </thead>


                                    <ng-container *ngFor="let parentQues of assignment.EvaluationQuestions; let pindex = index">
                                        <tbody *ngIf="QuestionParentFilter(parentQues)">

                                            <ng-container *ngFor="let childQues of assignment.EvaluationQuestions; let cindex = index">
                                                <tr *ngIf="QuestionChildFilter(parentQues,childQues) && (childQues.ParentQuestionID == null || childQues.IsShow)"
                                                    data-id="{{childQues.QuestionID}}"
                                                    data-parent-id="{{childQues.ParentQuestionID}}"
                                                    data-parent-criteria="{{childQues.ParentVisibilityCriteria}}">
                                                    <ng-container>

                                                        <td md-cell>
                                                            {{childQues.ParentQuestionID == null ? (pindex + 1) + '.' : ''}}
                                                        </td>
                                                        <td md-cell *ngIf="Role != 'Worker'" style="position:relative;"
                                                            [ngClass]="{'child': childQues.ParentQuestionID != null }">
                                                            {{childQues.ManagerDescription}}
                                                            <mat-icon class="ng-scope md-iwgNavbar-theme material-icons questionnaire-helpicon"
                                                                      *ngIf="childQues.HelpText != '' && childQues.HelpText != null"
                                                                      [matTooltip]="childQues.HelpText"
                                                                      matTooltipPosition="above">
                                                                help
                                                            </mat-icon>
                                                        </td>
                                                        <td *ngIf="Role == 'Worker'" style="position:relative;">
                                                            {{childQues.ContractorDescription}}
                                                            <mat-icon class="ng-scope md-iwgNavbar-theme material-icons questionnaire-helpicon"
                                                                      *ngIf="childQues.HelpText != '' && childQues.HelpText != null"
                                                                      [matTooltip]="childQues.HelpText"
                                                                      matTooltipPosition="above">
                                                                help
                                                            </mat-icon>
                                                        </td>
                                                        <td md-cell
                                                            *ngIf="IsManagerQuestionnaireEdit || IsContractorQuestionnaireEdit">
                                                            <ng-container *ngIf="assignment.IsAllowedToChange == true">
                                                                <div layout>

                                                                    <div class="md-input-container"
                                                                         *ngIf="childQues.QuestionFieldTypeID==2">
                                                                        <mat-radio-group aria-label="Select an option"
                                                                                         [(ngModel)]="childQues.Answer"
                                                                                         (change)="onQuestionOptionChange(childQues)">
                                                                            <mat-radio-button class="md-iwgBlue-theme"
                                                                                              *ngFor="let option of childQues.QuestionOptions"
                                                                                              [value]="option.FieldOption">
                                                                                {{option.FieldOption}}
                                                                            </mat-radio-button>
                                                                        </mat-radio-group>
                                                                        <span *ngIf="childQues.ShowValidation == true"
                                                                              class="requiredQuestion">
                                                                            Answer is
                                                                            required
                                                                        </span>
                                                                    </div>
                                                                    <div class="md-input-container"
                                                                         *ngIf="childQues.QuestionFieldTypeID==1">

                                                                        <mat-select [(ngModel)]="childQues.Answer"
                                                                                    (selectionChange)="onQuestionOptionChange(childQues)" placeholder="Please Select" class="mat-selectView">
                                                                            <mat-option *ngFor="let option of childQues.QuestionOptions"
                                                                                        [value]="option.FieldOption">
                                                                                {{option.FieldOption}}
                                                                            </mat-option>
                                                                        </mat-select>

                                                                        <span *ngIf="childQues.ShowValidation == true"
                                                                              class="requiredQuestion">
                                                                            Answer is
                                                                            required
                                                                        </span>
                                                                    </div>
                                                                    <div class="md-input-container mt-checkbox"
                                                                         *ngIf="childQues.QuestionFieldTypeID==4">

                                                                        <input type="hidden"
                                                                               [(ngModel)]="childQues.Answer" />
                                                                        <mat-checkbox class="example-margin"
                                                                                      *ngFor="let option of childQues.QuestionOptions"
                                                                                      class="md-iwgBlue-theme mat-check"
                                                                                      [checked]="isQuestionChecked(childQues, option)"
                                                                                      [value]="option.FieldOption"
                                                                                      (change)="onQuestionOptionChange(childQues, option)">
                                                                            {{option.FieldOption}}
                                                                        </mat-checkbox>
                                                                        <span *ngIf="childQues.ShowValidation == true"
                                                                              class="requiredQuestion">
                                                                            Answer is
                                                                            required
                                                                        </span>

                                                                    </div>
                                                                    <div class="md-input-container"
                                                                         *ngIf="childQues.QuestionFieldTypeID==3">
                                                                        <textarea matInput cdkTextareaAutosize
                                                                                  [(ngModel)]="childQues.Answer" class="dynmaic-area"
                                                                                  (change)="textAreaChange()"></textarea>
                                                                        <span *ngIf="childQues.ShowValidation == true"
                                                                              class="requiredQuestion">
                                                                            Answer is
                                                                            required
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </ng-container>
                                                        </td>
                                                        <td md-cell
                                                            *ngIf="!IsManagerQuestionnaireEdit && !IsContractorQuestionnaireEdit">
                                                            <span *ngIf="childQues.QuestionFieldTypeID != 4">{{childQues.Answer}}</span>
                                                            <ng-container *ngIf="childQues.QuestionFieldTypeID == 4">
                                                                <div *ngFor="let answer of childQues.AnswerList"
                                                                     style="padding:5px 0;" class="">{{answer}}</div>
                                                            </ng-container>
                                                        </td>
                                                    </ng-container>
                                                </tr>
                                            </ng-container>
                                        </tbody>
                                    </ng-container>
                                </table>
                                <div layout="row" class="iwg-form-buttons"
                                     *ngIf="IsManagerQuestionnaireEdit || IsContractorQuestionnaireEdit"
                                     style="margin: 15px 0px 15px 0px; text-align:center;">
                                    <button mat-button (click)="SaveDraftQuestions()"
                                            [ngClass]="{'is-hidden': assignment.IsAllowedToChange == false?true:false}"
                                            style="margin-left: 100px;background-color: #224d95;
                            color: rgba(255,255,255,0.87); margin-right: 20px;box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);">
                                        Save as Draft
                                    </button>
                                    <button mat-button class="mat-primary mat-raised iwg-mat-raised"
                                            (click)="SubmitQuestions()"
                                            [ngClass]="{'is-hidden': assignment.IsAllowedToChange == false?true:false}"
                                            style="background-color: #224d95;color: rgba(255,255,255,0.87);">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-tab>

                    <mat-tab label="Documents" *ngIf="ShowDocuments">
                        <div layout="row" layout-xs="column" class="assignmentdetailscloumns" *ngIf="assignment">
                            <app-assigmentdetail-document [AssignmentId]="assignmentId" [BussinessName]="BussinessName"
                                                          [AssignmentDisplayId]="AssignmentDisplayId" [ContractorName]="ContractorName"
                                                          [AssignmentStatusId]="AssignmentStatusId"></app-assigmentdetail-document>
                        </div>
                    </mat-tab>
                </mat-tab-group>
                <br>
                <ng-template #tabContent>
                    <div layout="row" layout-xs="column" style="margin-top: 15px;" class="assignmentdetailscloumns">
                        <div style="flex: none;">
                            <div class="iwg-widget-box" flex>
                                <div class="iwg-widget-box-header">{{workerLabel}} Information</div>
                                <div class="iwg-widget-box-body" layout="row">
                                    <div flex>
                                        <div class="iwg-widget-box-card">
                                            <label class="iwg-regular-label">{{workerLabel}} </label>
                                            <p class="iwg-regular-value" *ngIf="assignment?.Worker">
                                                {{assignment?.Worker?.Name | blank}}
                                            </p>
                                        </div>
                                        <div class="iwg-widget-box-card"
                                             *ngIf="(assignment?.Worker && assignment?.Worker?.CompanyName!= '' && assignment?.Worker?.CompanyName != null && assignment?.Worker?.CompanyName!=assignment?.Worker?.Name) && ( state.service==2 || state.service==3)">
                                            <label class="iwg-regular-label">Business Name</label>
                                            <p class="iwg-regular-value">{{assignment?.Worker?.CompanyName | blank}}</p>
                                        </div>

                                        <!-- eee allow this back in - GDPR-->
                                        <div class="iwg-widget-box-card">
                                            <p class="iwg-regular-value">
                                                <mat-icon style="float: left;">email</mat-icon>
                                                <a target="_top" href="mailto:{{assignment?.Worker?.ContactInfo.Email | blank}}">{{assignment?.Worker?.ContactInfo.Email | blank}}</a>
                                            </p>
                                        </div>
                                        <div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="iwg-widget-box"
                                 *ngIf="assignment?.Service?.ServiceTypeEnumID == 1 && assignment?.ShowOnboardingTab == true"
                                 flex>
                                <div class="iwg-widget-box-header">Onboarding Information</div>
                                <div class="iwg-widget-box-body" layout="row">
                                    <div flex>
                                        <div class="iwg-widget-box-card">
                                            <label class="iwg-regular-label">Onboarding Status</label>
                                            <p class="iwg-regular-value">
                                                {{getOnboardingCount(assignment?.onboardingOverallStatuses,1)}} of
                                                {{getOnboardingCount(assignment?.onboardingOverallStatuses,2)}} Steps
                                                Completed
                                            </p>
                                        </div>
                                        <div class="iwg-widget-box-card"
                                             *ngFor="let onboardingStatus of assignment?.onboardingOverallStatuses  let idx = index">
                                            <label class="iwg-regular-label">
                                                Step {{idx+1}} -
                                                {{onboardingStatus.CategoryName}}
                                            </label>
                                            <p class="iwg-regular-value">{{onboardingStatus.StatusDescription}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="spacebw"></div>
                        <div class="iwg-widget-box">
                            <div class="iwg-widget-box-header">{{assignmentLabel}} Information</div>
                            <div class="iwg-widget-box-body" layout="row">
                                <div flex>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">ID</label>
                                        <p class="iwg-regular-value">{{assignment?.DisplayID}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label"> {{assignmentLabel}} Status</label>
                                        <p class="iwg-regular-value">{{assignment?.Status.Name| blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 3">
                                        <label class="iwg-regular-label">Questionnaire Status</label>
                                        <p class="iwg-regular-value">{{assignment?.QuestionnaireStatus| blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="allowEndClients">
                                        <label class="iwg-regular-label">End Client</label>
                                        <p class="iwg-regular-value">{{assignment?.EndClientName| blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" layout="column" *ngIf="assignment?.SOWFile.Name">
                                        <label class="iwg-regular-label">Statement of Work</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;align-items: center;">
                                            {{assignment?.SOWFile.Name | blank}}
                                            <button mat-button class="mat-icon-button" [disabled]="isLoading"
                                                    *ngIf="assignment?.SOWFile.Name" (click)="downloadSOWFile()">
                                                <mat-icon>file_download</mat-icon>
                                            </button>
                                        </p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Team != null">
                                        <label class="iwg-regular-label">Team</label>
                                        <p class="iwg-regular-value">{{assignment?.Team.Name | blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Manager</label>
                                        <p class="iwg-regular-value">{{assignment?.Manager.Name | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Manager Job Title</label>
                                        <p class="iwg-regular-value">{{assignment?.Manager.JobTitle | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <p class="iwg-regular-value">
                                            <mat-icon style="float: left;">email</mat-icon>
                                            <a target="_top" href="mailto:{{assignment?.Manager.ContactInfo.Email | blank}}">{{assignment?.Manager.ContactInfo.Email | blank}}</a>
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1 && !US_EOR">
                                        <label class="iwg-regular-label">Business Entity in Country</label>
                                        <p class="iwg-regular-value">{{assignment?.EntityInCountry | yesNoBlank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Country of Citizenship</label>
                                        <p class="iwg-regular-value">{{assignment?.ExpatCountryName | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Worker Residence</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsExpat == true ? 'Expatriate' : 'Local'}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1 && assignment?.IsExpat == true">
                                        <label class="iwg-regular-label">Visa / Work Permit Required</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsExpatVisaNeeded == true ? 'Yes' : 'No'}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1 && assignment?.IsExpat == true">
                                        <label class="iwg-regular-label">Worker is in Country</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsExpatInCountry == true ? 'Yes' : 'No'}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1 && !US_EOR">
                                        <label class="iwg-regular-label">Offer Letter Sent to Worker</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsOfferLetterAttached | yesNoBlank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" layout="column"
                                         *ngIf="assignment?.OfferLetterFile.Name">
                                        <label class="iwg-regular-label">Offer Letter</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;align-items: center;">
                                            {{assignment?.OfferLetterFile.Name | blank}}
                                            <button mat-button class="mat-icon-button" [disabled]="isLoading"
                                                    *ngIf="assignment?.OfferLetterFile.Name"
                                                    (click)="downloadOfferLetterFile()">
                                                <mat-icon>file_download</mat-icon>
                                            </button>
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Notice Time</label>
                                        <p class="iwg-regular-value">{{assignment?.TimeForNotice | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Worksite Address</label>
                                        <p class="iwg-regular-value">
                                            Street 1:
                                            {{assignment?.WorksiteAddress.StreetAddress1}}
                                        </p>
                                        <p class="iwg-regular-value">
                                            Street 2:
                                            {{assignment?.WorksiteAddress.StreetAddress2}}
                                        </p>
                                        <p class="iwg-regular-value">City: {{assignment?.WorksiteAddress.City}}</p>
                                        <p class="iwg-regular-value">
                                            State/Region:
                                            {{assignment?.WorksiteAddress.Region.Name}}
                                        </p>
                                        <p class="iwg-regular-value">
                                            Postal Code:
                                            {{assignment?.WorksiteAddress.PostalCode}}
                                        </p>
                                        <p class="iwg-regular-value">
                                            Country:
                                            {{assignment?.WorksiteAddress.Country.Name | blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="assignment?.Service.ServiceTypeEnumID == 3 || assignment?.Service.ServiceTypeEnumID == 2">
                                        <label class="iwg-regular-label"
                                               *ngIf="assignment?.Service.ServiceTypeEnumID == 3">Worksite Location</label>
                                        <label class="iwg-regular-label"
                                               *ngIf="assignment?.Service.ServiceTypeEnumID == 2">Location</label>
                                        <p class="iwg-regular-value">State/Region: {{assignment?.Region?.Name  | blank}}</p>
                                        <p class="iwg-regular-value">Country: {{assignment?.Country?.Name | blank}}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="spacebw"></div>
                        <div class="iwg-widget-box ">
                            <div class="iwg-widget-box-header">{{jobLabel}} Information</div>
                            <div class="iwg-widget-box-body" layout="row">
                                <div flex>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">{{jobTitleLabel}}</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{this.utils.htmlDecode(assignment?.JobTitle) | blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 1 || (assignment?.Service.ServiceTypeEnumID != 1 && Role != 'Worker')">
                                        <label class="iwg-regular-label">{{jobDescriptionLabel}}</label>
                                        <pre style="font-size: 14px;color: #333;margin: 0;white-space: pre-line;font-family: Lato,Helvetica Neue,sans-serif;">{{assignment?.JobDescription | blank}}</pre>
                                    </div>

                                    <div class="iwg-widget-box-card" layout="column"
                                         *ngIf="assignment?.JobDescriptionFile.Name && Role != 'Worker'">
                                        <label class="iwg-regular-label">{{jobDescriptionLabel}} File</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;align-items: center;">
                                            {{assignment?.JobDescriptionFile.Name | blank}}
                                            <button mat-button class="mat-icon-button" [disabled]="isLoading"
                                                    *ngIf="assignment?.JobDescriptionFile.Name"
                                                    (click)="downloadJobDescriptionFile()">
                                                <mat-icon>file_download</mat-icon>
                                            </button>
                                        </p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 3">
                                        <label class="iwg-regular-label">Submitted</label>
                                        <p class="iwg-regular-value">{{assignment?.CreationDate | date}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Start Date</label>
                                        <p class="iwg-regular-value">{{assignment?.StartDate | date}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Estimated End Date</label>
                                        <p class="iwg-regular-value">{{assignment?.ExpectedEndDate | date | blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="(assignment?.Service.ServiceTypeEnumID <= 2 && Role != 'Worker') || assignment?.Service.ServiceTypeEnumID ==3">
                                        <label class="iwg-regular-label">Termination Notice Period</label>
                                        <p class="iwg-regular-value">{{assignment?.TerminationNoticePeriod | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Department</label>
                                        <p class="iwg-regular-value">{{assignment?.Department | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="(assignment?.Service.ServiceTypeEnumID <= 2 && Role != 'Worker') || assignment?.Service.ServiceTypeEnumID ==3">
                                        <label class="iwg-regular-label">Cost Center</label>
                                        <p class="iwg-regular-value">{{assignment?.CostCenter | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="(assignment?.Service.ServiceTypeEnumID <= 2 && Role != 'Worker') || assignment?.Service.ServiceTypeEnumID ==3">
                                        <label class="iwg-regular-label">PO</label>
                                        <p class="iwg-regular-value">{{assignment?.PO | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="assignment?.Service.ServiceTypeEnumID == 1 && assignment?.ExternalIdentifierLabel != ''">
                                        <label class="iwg-regular-label">{{assignment?.ExternalIdentifierLabel}}</label>
                                        <p class="iwg-regular-value">{{assignment?.ExternalIdentifier | blank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Pay Rate</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.PayRate | currency:(assignment?.PayCurrency.Symbol || ''):'symbol-narrow' : '1.2-2'}}
                                            ({{assignment?.PayCurrency.Abbreviation}}) /
                                            {{assignment?.PayRateTimeframe.Name | blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 2">
                                        <label class="iwg-regular-label">Charge Types</label>
                                        <ul>
                                            <li style="display: list-item;" class="iwg-regular-value" *ngFor="let item of assignment?.ChargeTypes">
                                                {{item}}
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && (assignment?.Service.ServiceTypeEnumID == 3 || assignment?.Service.ServiceTypeEnumID == 2)">
                                        <label class="iwg-regular-label">Total Project Amount</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.PayRate | currency:(assignment?.PayCurrency.Symbol || ''):'symbol-narrow' : '1.2-2'}}
                                            ({{assignment?.PayCurrency.Abbreviation}})
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="assignment?.Service.ServiceTypeEnumID == 3 || assignment?.Service.ServiceTypeEnumID == 2">
                                        <label class="iwg-regular-label"
                                               *ngIf="assignment?.Service.ServiceTypeEnumID == 2">Pay Structure</label>
                                        <label class="iwg-regular-label"
                                               *ngIf="assignment?.Service.ServiceTypeEnumID == 3">Payment Structure</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.PayRateTimeframeStructure.Name | blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="assignment?.Service.ServiceTypeEnumID == 2">
                                        <label class="iwg-regular-label">Pay Amount</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.PartnerInvoiceTotal | currency:(assignment?.PayCurrency.Symbol || ''):'symbol-narrow' : '1.2-2'}}
                                            ({{assignment?.PayCurrency.Abbreviation}})
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Weekly Hours</label>
                                        <p class="iwg-regular-value">{{assignment?.HoursPerWeek | number : '2.0-0'}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                        <label class="iwg-regular-label">Full-time or Part-time</label>
                                        <p class="iwg-regular-value">
                                            {{ (assignment?.IsPartime) ? 'Part-time' : 'Full-time'}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                        <label class="iwg-regular-label">Regular or Sporadic</label>
                                        <p class="iwg-regular-value">
                                            {{ (assignment?.IsSproradic) ? 'Sproadic' : 'Regular'}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="US_EOR">
                                        <label class="iwg-regular-label">Exempt Reason</label>
                                        <p class="iwg-regular-value">
                                            {{ assignment?.ExemptStatus | blank }}
                                        </p>
                                    </div>



                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Overtime Authorized</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsOvertimeAuthorized | yesNoBlank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Expense Reimbursement Authorized</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsExpensesAuthorized | yesNoBlank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Commissions Authorized</label>
                                        <p class="iwg-regular-value">
                                            {{assignment?.IsCommissionAuthorized | yesNoBlank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Bonuses Authorized</label>
                                        <p class="iwg-regular-value">{{assignment?.IsBonusAuthorized | yesNoBlank}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Compensation Details</label>
                                        <p class="iwg-regular-value">{{assignment?.OtherCompensation | blank}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Travel Required</label>
                                        <p class="iwg-regular-value">{{assignment?.IsTravelRequired | yesNo}}</p>
                                    </div>
                                    <div class="iwg-widget-box-card"
                                         *ngIf="assignment?.Service.ServiceTypeEnumID == 1 && assignment?.IsTravelRequired == true">
                                        <label class="iwg-regular-label">Travel Locations</label>
                                        <p class="iwg-regular-value">{{assignment?.TravelLocations}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Driving Required</label>
                                        <p class="iwg-regular-value">{{assignment?.IsDrivingRequired | yesNo}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card" *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1">
                                        <label class="iwg-regular-label">Equipment Provided</label>
                                        <p class="iwg-regular-value">{{assignment?.IsEquipmentProvided | yesNo}}</p>
                                    </div>

                                    <div class="iwg-widget-box-card"
                                         *ngIf="Role != 'Worker' && assignment?.Service.ServiceTypeEnumID == 1 && assignment?.EquipmentProvided != '' && assignment?.EquipmentProvided != null">
                                        <label class="iwg-regular-label">Equipment List</label>
                                        <p class="iwg-regular-value">{{assignment?.EquipmentProvided  | blank}}</p>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div class="spacebw" *ngIf="assignment?.Service.ServiceTypeEnumID == 3"></div>
                        <div class="iwg-widget-box" flex
                             *ngIf="assignment?.Service.ServiceTypeEnumID == 3 && Role != 'Worker'">
                            <div class="iwg-widget-box-header">Recommendation</div>
                            <div class="iwg-widget-box-body" layout="row" *ngIf="assignment?.Status.ID == 9">
                                <div flex>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Recommendation</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{assignment?.Recommendation  | blank}}
                                        </p>
                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Reasons</label>
                                        <p class="iwg-regular-value"
                                           style="overflow-wrap: break-word;white-space: pre-wrap;"
                                           [innerHTML]="assignment?.EvaluationComments"></p>

                                    </div>
                                    <div class="iwg-widget-box-card">
                                        <label class="iwg-regular-label">Date of Recommendation</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            {{assignment?.EvaluationDate  | date}}
                                        </p>
                                    </div>

                                    <div class="iwg-widget-box-card"
                                         *ngIf="assignment?.Evaluation!='' && assignment?.Evaluation!=null">
                                        <label class="iwg-regular-label">Questionnaire</label>
                                        <p class="iwg-regular-value"
                                           style="width:250px; overflow-wrap: break-word;white-space: normal;">
                                            <a target="_blank" href="{{assignment?.Evaluation}}">Questionnaire</a>
                                        </p>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>


                </ng-template>
            </div>
        </div>
        <div *ngIf="showFooter" class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>
